import { createFileRoute, notFound } from "@tanstack/react-router";
import { EmbedWidget } from "@/components/prayer/EmbedWidget";
import { findKecamatan } from "@/data/locations";

export const Route = createFileRoute("/embed/jadwal-imsak/$kota/$kec")({
  loader: ({ params }) => {
    const loc = findKecamatan(params.kota, params.kec);
    if (!loc) throw notFound();
    return { loc };
  },
  head: () => ({ meta: [{ name: "robots", content: "noindex" }] }),
  component: () => {
    const { loc } = Route.useLoaderData();
    return <EmbedWidget variant="imsak" location={loc} />;
  },
});
